import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import Container from './Container';
import logo from '../../../src/img/logoGuarda.png';
import styles from './Navbar.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';

function Navbar({ links }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState([]); // Controle dos menus expandidos
    const navRef = useRef(null);
    const navigate = useNavigate();
    const { isAuthenticated } = useContext(UserContext);

    const toggleMenu = () => {
        setMenuOpen((prev) => {
            const isOpening = !prev;
            if (isOpening) {
                setExpandedMenus(null); // Fecha todos os dropdowns
            }
            return isOpening;
        });

        if (!menuOpen) {
            document.body.classList.add('menuOpen');
        } else {
            document.body.classList.remove('menuOpen');
        }
    };


    const handleDropdownToggle = (label) => {
        // Expande o menu clicado e fecha os outros
        setExpandedMenus((prev) => (prev === label ? null : label));
    };

    const handleLogoClick = () => {
        if (isAuthenticated) {
            navigate('/home-adm'); // Redireciona para Home Administrador
        } else {
            navigate('/'); // Redireciona para PublicHome
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setMenuOpen(false);
                setExpandedMenus([]); // Fecha todos os dropdowns
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        return () => {
            document.body.classList.remove('menuOpen'); // Remove a classe ao desmontar o componente
        };
    }, []);


    return (
        <nav className={styles.navbar} ref={navRef}>
            <Container customClass="container-navbar">
                <img
                    src={logo}
                    alt="Logo do GuardAí"
                    className={styles.logo}
                    onClick={handleLogoClick}
                    role="button"
                    style={{ cursor: 'pointer' }}
                />
                <div
                    className={styles.hamburger}
                    onClick={toggleMenu}
                    aria-expanded={menuOpen}
                    aria-controls="main-menu"
                >
                    {menuOpen ? '✕' : '☰'}
                </div>
                <ul className={`${styles.list} ${menuOpen ? styles.menuOpen : ''}`} id="main-menu">
                    {links.map((link) =>
                        link.submenu ? (
                            <li
                                key={link.label}
                                className={`${styles.item} ${expandedMenus === link.label ? styles.expanded : ''}`}
                            >
                                <span
                                    className={styles.dropdownToggle}
                                    onClick={() => handleDropdownToggle(link.label)}
                                >
                                    {link.label}{' '}
                                    <FontAwesomeIcon
                                        icon={expandedMenus === link.label ? faChevronUp : faChevronDown}
                                    />
                                </span>
                                {expandedMenus === link.label && (
                                    <ul className={styles.expandedMenu}>
                                        {link.submenu.map((sublink) => (
                                            <li key={sublink.path} className={styles.dropdownItem}>
                                                <Link
                                                    to={sublink.path}
                                                    onClick={() => {
                                                        setMenuOpen(false); // Fecha o menu
                                                        setExpandedMenus(null); // Fecha qualquer submenu
                                                    }}
                                                >
                                                    {sublink.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ) : (
                            <li
                                key={link.path}
                                className={`${styles.item} ${link.label === 'Sistema Gestor' ? 'sistemaGestor' : ''}`}
                            >
                                <Link
                                    to={link.path}
                                    className={link.path === '/login' ? styles.buttonLink : ''}
                                    onClick={() => {
                                        setMenuOpen(false); // Fecha o menu
                                        setExpandedMenus(null); // Fecha qualquer submenu
                                    }}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        )
                    )}
                </ul>

            </Container>
        </nav>
    );
}

export default Navbar;
